import { Grid, Stack, styled } from '@mui/material'
import { Child } from '../../../../containers/common/child'
import { GItem } from '../grids'
import { UnitTitle } from './unitTitle'
import { OperationId } from '../../../../containers/common/constant/operationLog'
import { yesNo } from '../../../../containers/common/constant/classification'
import { memberModifyChildAddressUrl } from '../../../../containers/common/constant/appUrl'
import { translate } from '../../../../i18n'

interface ChildAddressUnitProps {
  child: Child | undefined
  sectionLabel: string
  hideLink?: boolean
  LabelItem: any
  ValueItem: any
}

export const ChildAddressUnit = (props: ChildAddressUnitProps) => {
  const { child, sectionLabel, LabelItem, ValueItem } = props

  const ChildContentAttribute = styled(Grid)({
  padding: '0 0 0 3rem',
  })
  
  let hasAddressFlag = false
  hasAddressFlag = child?.sameAddressFlag != null || child?.tel != null || child?.postalCode != null || child?.address1 != null || child?.address2 != null || child?.buildingNameRoomNumber != null
 
  return (
    <>
      <Stack spacing={1}>
        {child != null && <UnitTitle title={sectionLabel} linkTo={memberModifyChildAddressUrl.url(child.childId)} operationLog={{ operationId: OperationId.OP_00000234 }} hideLink={props.hideLink} />}
          {child != null && hasAddressFlag === true && child?.sameAddressFlag !== yesNo.yes &&  
            <>  
              <div>
                <ChildContentAttribute container>
                  <LabelItem>{translate('system.userContent.label.postalCode')}</LabelItem>
                  <ValueItem>{child.postalCode}</ValueItem>
                  <LabelItem>{translate('system.userContent.label.prefecturesAndMunicipalities')}</LabelItem>
                  <ValueItem>{child.address1}</ValueItem>
                  <LabelItem>{translate('system.userContent.label.address')}</LabelItem>
                  <ValueItem>{child.address2}</ValueItem>
                  <LabelItem>{translate('system.userContent.label.buildingNameRoomNumber')}</LabelItem>
                  <ValueItem>{child.buildingNameRoomNumber}</ValueItem>
                  <LabelItem>{translate('system.userContent.label.tel')}</LabelItem>
                  <ValueItem>{child.tel}</ValueItem>
                </ChildContentAttribute>
              </div>
            </>
          }
        {hasAddressFlag === false && <GItem xs={12}>登録なし</GItem>}
        {child?.sameAddressFlag === yesNo.yes && <GItem xs={12}>保護者と同じ</GItem>}
      </Stack>
    </>
  )
}
